import { render, staticRenderFns } from "./SchoolsModal.vue?vue&type=template&id=9ad957c4&"
import script from "./SchoolsModal.vue?vue&type=script&lang=js&"
export * from "./SchoolsModal.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports